import React, { createContext, useContext, useState, ReactNode } from 'react';
import { DialogProps } from './types';

interface DialogContextProps {
  dialog: DialogProps | null;
  openDialog: (dialog: DialogProps) => void;
  closeDialog: () => void;
}

const DialogContext = createContext<DialogContextProps>(
  {} as DialogContextProps
);  

export const useDialogs = () => {
  const context = useContext(DialogContext);
  if (!context) {
    throw new Error('useDialogs must be used within a DialogProvider');
  }
  return context;
};

export const DialogProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [dialog, setDialog] = useState<DialogProps | null>(null);

  const openDialog = (dialog: DialogProps) => setDialog(dialog);
  const closeDialog = () => setDialog(null);

  return (
    <DialogContext.Provider value={{ dialog, openDialog, closeDialog }}>
      {children}
    </DialogContext.Provider>
  );
};
